import { render, staticRenderFns } from "./PackageTypesRegistryEditForm.vue?vue&type=template&id=a6170c76"
import script from "./PackageTypesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./PackageTypesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports